import React, { useEffect, useState } from 'react'
import WebComponentContainer from '../generic/WebComponentContainer'
import { BrowserUtils } from '../../utils/siteUtils'
import useEventBus from '../generic/useEventBus'

export default ({ prospectId, isRequiredPhotos = false, isNextClicked = false, allWebComponentPhotosUploaded = false, environment, updateGlobalState, theme }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [showLoader, setShowLoader] = useState(true)
  const shouldShowError = isNextClicked && !allWebComponentPhotosUploaded

  useEffect(() => {
    const cacheBust = Date.now()
    BrowserUtils.addScript(`${environment.funnelWebComponentUrl}?${cacheBust}`, document.head, 'module', false)
    setPageLoaded(true)
  }, [])

  const updateAllPhotosUploadedState = imageUrls => {
    updateGlobalState({ photoUploadedUrls: imageUrls, allWebComponentPhotosUploaded: imageUrls.every(url => url !== '') })
  }

  useEventBus('LoadImagesSuccess', ({ imageUrls }) => {
    updateAllPhotosUploadedState(imageUrls)
    setShowLoader(false)
  })
  useEventBus('UploadSuccess', ({ imageUrls }) => {
    updateAllPhotosUploadedState(imageUrls)
  })
  useEventBus('DeleteSuccess', ({ imageUrls }) => {
    updateAllPhotosUploadedState(imageUrls)
  })
  useEventBus('LoadImagesFail', () => {
    setShowLoader(false)
  })

  return (
    <WebComponentContainer pageLoadingComplete={pageLoaded} withLoader={showLoader} maxWidth="100%" location={'imagecapture'} theme={theme}>
      <image-capture-hydrator image-group-guid={prospectId} requires-all-photos={isRequiredPhotos} should-show-error={shouldShowError} theme={theme}>
        <image-capture />
      </image-capture-hydrator>
    </WebComponentContainer>
  )
}
